import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import ReactMarkdown from "react-markdown";

/**
 * Item descriptions are plain text, but clinics moving from their own
 * storefront often paste simple lists and bold text, so render light markdown.
 * react-markdown never renders raw HTML.
 */
export function ShopItemDescription(t0) {
  const $ = _c(3);
  const {
    text
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      p: _temp,
      ul: _temp2,
      ol: _temp3,
      strong: _temp4,
      h1: _temp5,
      h2: _temp6,
      h3: _temp7,
      a: _temp8,
      img: _temp9
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== text) {
    t2 = <div className="space-y-3 text-body leading-relaxed text-foreground-secondary"><ReactMarkdown components={t1}>{text}</ReactMarkdown></div>;
    $[1] = text;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function _temp9() {
  return null;
}
function _temp8(t0) {
  const {
    children: children_6
  } = t0;
  return <span>{children_6}</span>;
}
function _temp7(t0) {
  const {
    children: children_5
  } = t0;
  return <h4 className="text-body-emphasis text-foreground">{children_5}</h4>;
}
function _temp6(t0) {
  const {
    children: children_4
  } = t0;
  return <h3 className="text-h4 text-foreground">{children_4}</h3>;
}
function _temp5(t0) {
  const {
    children: children_3
  } = t0;
  return <h3 className="text-h4 text-foreground">{children_3}</h3>;
}
function _temp4(t0) {
  const {
    children: children_2
  } = t0;
  return <strong className="font-semibold text-foreground">{children_2}</strong>;
}
function _temp3(t0) {
  const {
    children: children_1
  } = t0;
  return <ol className="list-decimal space-y-1 pl-5">{children_1}</ol>;
}
function _temp2(t0) {
  const {
    children: children_0
  } = t0;
  return <ul className="list-disc space-y-1 pl-5">{children_0}</ul>;
}
function _temp(t0) {
  const {
    children
  } = t0;
  return <p className="whitespace-pre-line">{children}</p>;
}